import { Link } from "react-router-dom";
import { useStateContext } from "../../Contexts/ContextProvider";
import Paper from "./Paper";
import AxiosClient from "../../assets/AxiosClient";
const PaperRow = ({ paper  }) => {
const {API}= useStateContext() ; 
const handleDownload = () => {
  AxiosClient.get(`${API}${paper.Link}`, { responseType: 'blob' })
      .then(response => response.data)
      .then(blob => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const a = document.createElement('a');
          a.href = url;
          a.download = `${paper.Auther}_${paper.title}.pdf`;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
      })
      .catch(() => window.alert('Unable to download this paper.'));
};
  return (
    <>
      <tr>
    
        <td>
           
              <h6 className="mb-0 text-sm">{paper.Auther  } </h6>
        </td>

        <td>
        <h6 className="mb-0 text-sm">{paper.title  } </h6>
        </td>
        <td>
        <button className="btn btn-danger" onClick={handleDownload}>Download</button>        </td>
        <td>
        <h6 className="mb-0 text-sm">{paper.status  } </h6>

        </td>
      
        <td className="align-middle">
          <Link className="btn btn-dark">
            View Paper
          </Link>
        </td>
      </tr>
    </>
  )
}

export default PaperRow; 